import { render, staticRenderFns } from "./saved-content.vue?vue&type=template&id=6d83a2de"
import script from "./saved-content.vue?vue&type=script&lang=js"
export * from "./saved-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports